import React from "react"
import ReactDOM from "react-dom"
import "./index.scss"
import App from "./App"
import { ToastContainer } from "react-toastify"
import { BrowserRouter } from "react-router-dom"
import reportWebVitals from "./reportWebVitals"

import "react-toastify/dist/ReactToastify.min.css"
import "react-mde/lib/styles/css/react-mde-all.css"

import "./i18n"
import "./fa"

import UserContextProvider from "./hooks/UserContext"

ReactDOM.render(
  <React.StrictMode>
    <UserContextProvider>
      <BrowserRouter>
        <App />

        <ToastContainer
          position="bottom-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable={false}
          pauseOnHover
        />
      </BrowserRouter>
    </UserContextProvider>
  </React.StrictMode>,
  document.getElementById("root")
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
